/**
 * `/$org/apps/imanage/about`: what iManage does in Amoreg, and the person's
 * connection — status, Reconnect, Disconnect. Disconnected, the area shows
 * the landing here as everywhere else.
 *
 * @module routes/$org.apps.imanage.about
 */
import { createFileRoute } from "@tanstack/react-router";

import { IManageAboutPage } from "../components/apps/imanage/IManageLanding";

export const Route = createFileRoute("/$org/apps/imanage/about")({
  component: IManageAboutPage,
});
